"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
const TriggerHistory = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 16,
  height: 16,
  viewBox: "5 5 18 18",
  fill: "none"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  className: "fill",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.595 12.222l1.721-1.722H13.16l3-6h-5.617l-5 10h3.508l-3 6h2.265l2.619-2.619c.074-1.517.656-2.821 1.748-3.913 1.091-1.091 2.395-1.673 3.912-1.746z",
  fill: "#7E8A9A"
}), /*#__PURE__*/_react.default.createElement("path", {
  className: "fill",
  d: "M16.93 13.249a5 5 0 110 10 5 5 0 010-10zm0 1a4 4 0 100 8 4 4 0 000-8zm0 1a.5.5 0 01.496.441l.004.059v2.293l1.353 1.353a.5.5 0 01-.66.749l-.047-.041-1.5-1.5a.5.5 0 01-.142-.289l-.004-.065v-2.5a.5.5 0 01.5-.5z",
  fill: "#7E8A9A"
}));
var _default = exports.default = TriggerHistory;